import {Component} from '@angular/core';
import {BlockBaseComponent} from "../block-base/block-base.component";
import {StoreSelectorsService} from "../../../../services/store-selectors.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslocoService} from "@ngneat/transloco";
import {faHammer} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'app-block-generic',
    templateUrl: './block-generic.component.html',
    styleUrls: ['./block-generic.component.scss']
})
export class BlockGenericComponent extends BlockBaseComponent {

    faHammer = faHammer;
    constructor(private translocoService: TranslocoService, public override storeSelector: StoreSelectorsService, public override dialog: MatDialog) {
        super(storeSelector, dialog);
    }

    override submit(formValues) {
        return super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [];
        //     {
        //         type: "input",
        //         value: '',
        //         label: this.translocoService.translate('general.text', {}, this.translocoService.getActiveLang()),
        //         inputType: "text",
        //         name: "Text",
        //         storePath: 'Data[0].Label[0].Text'
        //     }
        // ];
    }
}
